module.exports = __webpack_public_path__ + "img/browse-vehicles-background-hyundai.a8ed8400.png";